<template>
  <div class="shopping-cart-promo">
    <promo-details v-if="promoInfo"></promo-details>
    <template v-else>
      <span class="iw-hyperlink shopping-cart-promo__text">Have a promo code?</span>
      <promo-code-input-custom></promo-code-input-custom>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PromoDetails from "./promo-details/PromoDetails";
import PromoCodeInputCustom from "./promo-input/templates/components/PromoCodeInputCustom";

export default {
  name: "ShoppingCartPromo",
  components: {
    PromoDetails,
    PromoCodeInputCustom
  },
  computed: {
    ...mapGetters({
      promoInfo: "cart/getPromoInfo"
    })
  }
};
</script>

<style scoped lang="scss">
.shopping-cart-promo {
  position: relative;
  font-family: $fontFamilyPrimary;
  display: grid;
  justify-content: normal;
  width: 100%;

  &__text {
    padding-top: 35px;
    padding-bottom: 6px;
    color: $group-3-color-2;
  }

  &-form {
    width: 100%;
    margin-bottom: (32px - 15px);
  }
}
</style>
